<template>
  <div class="ConsultingLong CommonContentSingle-gray ConsultingLong">
    <el-dialog :title="$t('original.languages231')" :visible.sync="dialogTableVisible" width="520px" append-to-body
      @close="clearAddInformation()">

      <el-form ref="form" :model="form" label-width="80px">
        <table class="ConsultingLong" style="width: 100%;">

          <tr v-if="this.Global.pdroleid(1057)">
            <td class="td_left" style="display: inline-block; padding-top: 9px;"> 咨询师：</td>

            <!-- Counselor_list -->
            <td class="td_right">

              <el-select @change="Counselor_change()" style="width: 300px;padding-bottom: 10px;"  v-model="Counselor" placeholder="请选择">
                <el-option v-for="(item, i) in Counselor_list" :key="i" :label="item.value" :value="item.key">
                  <!-- :disabled="item.Disabled" -->
                </el-option>
              </el-select>
            </td>
          </tr>

          <tr v-else>
            <td class="td_left"> {{ $t('original.languages225') }}：</td>
            <td class="td_right">{{ addInformation.RealName }}</td>
          </tr>

          <tr>
            <td class="td_left">{{ $t('original.languages207') }}：</td>
            <td class="td_right">
              <el-select style="width: 300px;" filterable @change="selectVsitorName()" v-model="addInformation.UserID" :placeholder="$t('original.languages3')">
                <el-option v-for="(item,i) in VsitorNameList" :key="i" :label="item.RealName" :value="i" :disabled="item.Disabled" >
                  <!-- :disabled="item.Disabled" -->
                </el-option>
              </el-select>
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">咨询时间</td>
            <td class="td_right" style="padding-top:10px">
              <el-select style="width: 300px;" filterable @change="zxtime()" v-model="aaa1" :placeholder="$t('original.languages3')">
                <el-option v-for="(item, i) in xsdata" :key="i" :label="item.Day" :value="i" >
                </el-option>
              </el-select>
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">咨询时段</td>
            <td class="td_right" style="padding-top:10px">
              <el-select style="width: 300px;" filterable v-model="addInformation.ConsultingLongtime" :placeholder="$t('original.languages3')" @change="xztm">
                <el-option v-for="(item, i) in aaa2" :key="i" :label="item.Time" :value="item.Time" >
                </el-option>
              </el-select>
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">{{ $t('original.languages208') }} </td>
            <td class="td_right">
              {{ addInformation.ConsultTheme }}
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left"> {{ $t('original.languages209') }}</td>
            <td class="td_right">
              {{ addInformation.ConsultCntIntroduce }}
            </td>
          </tr>

          <!-- <tr v-if="addInformationShow">
            <td class="td_left"> {{ $t('original.languages272') }}</td>
            <td class="td_right">
              {{ addInformation.ConsultingLongWeek + '|' + addInformation.ConsultingLongtime }}
            </td>
          </tr> -->

          <tr v-if="addInformationShow">
            <td class="td_left"> {{ $t('original.languages226') }}</td>
            <td class="td_right">
              {{ addInformation.ConAddressName }}
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left"> {{ $t('original.languages212') }}</td>
            <el-radio-group style="margin-left:0px" v-model="ConsultType">
              <el-radio :disabled="pasx1" label="0">线下</el-radio>
              <el-radio :disabled="pasx2" label="1">线上</el-radio>
            </el-radio-group>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left"> {{ $t('original.languages276') }}</td>
            <td class="td_right">
              {{ addInformation.DeptName }}
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left">剩余次数</td>
            <td class="td_right">
              {{ addInformation.Rest }} 次
            </td>
          </tr>

          <tr v-if="addInformationShow">
            <td class="td_left"> {{ $t('original.languages213') }}</td>
            <td class="td_right">
              <el-input type="textarea" maxlength="200" v-model="addInformation.ConsultingLongCause" resize="none"></el-input>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              <div class="buttons" style="width: 100%;">
                <el-button @click="dialogTableVisible = false">{{ $t('original.cancel') }}</el-button>
                <el-button type="primary" :loading="iscontinuous" @click="AddConsultingLong()">
                  {{ $t('original.languages266') }}
                </el-button>
              </div>
            </td>
          </tr>

        </table>
      </el-form>
    </el-dialog>

    <el-dialog :title="$t('original.languages50')" :visible.sync="dialoginfoVisible" width="520px" append-to-body @close="clearAddInformation()">
      <el-form ref="form" label-width="80px">
        <table class="ConsultingLong" style="width: 100%;border-radius: 4px;">
          
          <tr>
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages185') }}：</td>
            <td class="td_right">{{ AppointmentInfo.CounselorID }}</td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages277') }}：</td>
            <td class="td_right">
              {{AppointmentInfo.RealName + '(' + AppointmentInfo.UserID + ')'}}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages208') }}：</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.ConsultTheme }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages209') }}：</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.ConsultCntIntroduce }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">时间：</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.aaa1 }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">时间段：</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.aaa2 }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages226') }}：</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.ConAddressName }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages276') }}：</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.DeptName }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">咨询方式：</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.ConsultType }}
            </td>
          </tr>

          <tr>
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages213') }}：</td>
            <td class="td_lefttd_right">
              {{ AppointmentInfo.ConsultingLongCause }}
            </td>
          </tr>

        </table>
        <table class="ConsultingLong" style="width: 100%;">
          <tr>
            <td class="td_left" style="padding: 10px; width: 25%;">审批状态</td>
            <td class="td_right">
              <!-- {{
                  AppointmentInfo.ConsultingLongState == 1 ? $t('original.languages252') : AppointmentInfo.ConsultingLongState == 2 ? $t('original.languages203') : AppointmentInfo.ConsultingLongState == 4 ? $t('original.languages205') : $t('original.languages204')
              }} -->
              <span v-if="AppointmentInfo.ConsultingLongStateCN == '已撤销'" style="background: rgba(141, 141, 141, 0.1);color: rgba(141, 141, 141, 1);">{{ AppointmentInfo.ConsultingLongStateCN }}</span>

              <span v-if="AppointmentInfo.ConsultingLongStateCN == '已同意'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(21, 191, 109, 1);">{{ AppointmentInfo.ConsultingLongStateCN }}</span>

              <span v-if="AppointmentInfo.ConsultingLongStateCN == '已拒绝'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(242, 75, 78, 1);">{{ AppointmentInfo.ConsultingLongStateCN }}</span>

              <span v-if="AppointmentInfo.ConsultingLongStateCN == '申请中'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(29, 154, 255, 1);">{{ AppointmentInfo.ConsultingLongStateCN }}</span>

              <span v-if="AppointmentInfo.ConsultingLongStateCN == '学员撤销'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(242, 75, 78, 1);">{{ AppointmentInfo.ConsultingLongStateCN }}</span>

              <span v-if="AppointmentInfo.ConsultingLongStateCN == '取消申请已同意'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(21, 191, 109, 1);">{{ AppointmentInfo.ConsultingLongStateCN }}</span>

            </td>
          </tr>

          <tr v-if="AppointmentInfo.ConsultingLongState == 2">
            <td class="td_left" style="padding: 10px;">{{ $t('original.note') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ConsultingLongNotes }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.ConsultingLongState == 3">
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages215') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ConsultingLongNotes }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.ConsultingLongState != 1 && AppointmentInfo.ConsultingLongState != 4">
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages192') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ApproverID }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.ConsultingLongState != 1 && AppointmentInfo.ConsultingLongState != 4">
            <td class="td_left" style="padding: 10px;">{{ $t('original.languages193') }}</td>
            <td class="td_right">
              {{ AppointmentInfo.ApproverTime }}
            </td>
          </tr>

          <tr v-if="AppointmentInfo.ConsultingLongState == 1">
            <td colspan="2">

              <div class="buttons" style="width: 100%; text-align: right;">
                <el-button @click="dialoginfoVisible = false">{{ $t('original.cancel') }}</el-button>
                <el-button style="margin-right: 20px;" type="primary" :loading="evocationload" @click="evocation(AppointmentInfo.ConsultingLongID)">
                  {{ $t('original.languages253') }}
                </el-button>
              </div>
            </td>
          </tr>

        </table>
      </el-form>
    </el-dialog>

    <el-container>
      <el-header style="background: rgba(255, 255, 255, 1);max-height: 206px;">

        <el-form ref="form" :inline="true" :model="form" label-width="80px" style="background: rgba(255, 255, 255, 1);height: 42px;">
          <el-form-item :label="$t('original.account')">
            <el-input v-model="form.UserID" :placeholder="$t('original.languages254')"></el-input>
          </el-form-item>
          <el-form-item v-if="this.Global.pdroleid(1057)" label="所在部门" prop="bumen">
            <div class="block">
              <el-cascader ref="wcascader" @change="Selected_to_shut_dow" v-model="form.DepartID" @expand-change="bumen" :options="data"
          :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>
            </div>
          </el-form-item>

          <el-form-item label="审批状态">
            <el-select v-model="form.CancelApproval" :placeholder="$t('original.languages3')">
              <el-option label="全部" value="0"></el-option>
              <el-option label="申请中" value="1"></el-option>
              <el-option label="已同意" value="2"></el-option>
              <el-option label="已拒绝" value="3"></el-option>
              <el-option label="已撤销" value="4"></el-option>
              <el-option label="学员撤销" value="5"></el-option>
              <el-option label="取消申请已同意" value="6"></el-option>
            </el-select>
          </el-form-item> 

          <el-form-item>
            <el-button type="primary" @click="aaa1fun()">{{ $t('original.screening') }}</el-button>
            <el-button type="primary" @click="clearFrom()"> {{ $t('original.reset') }}</el-button>
          </el-form-item>

        </el-form>
      </el-header>
      <el-main style="margin-top: 15px; background: rgba(255, 255, 255, 1);">
        <el-row>
          <el-col :xl="24" style="margin-bottom: 15px;">
            <el-button type="primary" :loading="loadingstart" @click="getVsitorNameList()">
              {{ $t('original.languages231') }}
            </el-button>
            <el-button type="primary" @click="; (outerVisible = true), xacs()">
              {{ $t('original.languages278') }}
            </el-button>
          </el-col>
          <el-table ref="multipleTable" v-loading="load" :element-loading-text="$t('original.languages22')"
            element-loading-spinner="el-icon-loading" :data="tableData" tooltip-effect="dark" style="width: 100%;">
            <el-table-column :label="$t('original.The_serial_number')" min-width="6%">
              <template slot-scope="scope">
                {{ (form.pageIndex - 1) * 10 + scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="UserID" :label="$t('original.account')" min-width="10%"></el-table-column>
            <el-table-column prop="RealName" :label="$t('original.name')" min-width="10%"></el-table-column>
            <el-table-column prop="Sex" :label="$t('original.gender')" min-width="6%"></el-table-column>
            <el-table-column prop="Age" :label="$t('original.languages256')" min-width="6%"></el-table-column>
            <el-table-column prop="DeptName" :label="$t('original.languages276')" min-width="20%"></el-table-column>
            <el-table-column prop="CreatedTime" :label="$t('original.languages217')" min-width="10%"></el-table-column>
            <el-table-column prop="ConsultingLongStateCN" label="审批状态" min-width="8%">
              <template slot-scope="scope">
                <!-- <span :class="scope.row.ConsultingLongState == 1 ? 'Statusblue' : scope.row.ConsultingLongState == 2 ? 'Statusgreen' : scope.row.ConsultingLongState == 4 ? 'Statusgray' : 'Statusred'
                ">
                  {{scope.row.ConsultingLongState == 1 ? $t('original.languages227') : scope.row.ConsultingLongState == 2 ? $t('original.languages203') : scope.row.ConsultingLongState == 4 ? $t('original.languages205') : $t('original.languages204')
                  }}
                </span> -->
                <span v-if="scope.row.ConsultingLongStateCN == '已撤销'" style="background: rgba(141, 141, 141, 0.1);color: rgba(141, 141, 141, 1);">{{ scope.row.ConsultingLongStateCN }}</span>
                <span v-if="scope.row.ConsultingLongStateCN == '已同意'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(21, 191, 109, 1);">{{ scope.row.ConsultingLongStateCN }}</span>
                <span v-if="scope.row.ConsultingLongStateCN == '已拒绝'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(242, 75, 78, 1);">{{ scope.row.ConsultingLongStateCN }}</span>
                <span v-if="scope.row.ConsultingLongStateCN == '申请中'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(29, 154, 255, 1);">{{ scope.row.ConsultingLongStateCN }}</span>
                <span v-if="scope.row.ConsultingLongStateCN == '学员撤销'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(242, 75, 78, 1);">{{ scope.row.ConsultingLongStateCN }}</span>
                <span v-if="scope.row.ConsultingLongStateCN == '取消申请已同意'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(21, 191, 109, 1);">{{ scope.row.ConsultingLongStateCN }}</span>
                <span v-if="scope.row.ConsultingLongStateCN == '取消申请中'" style="background-color: rgba(36, 153, 255, 1);color: #fff;">{{ scope.row.ConsultingLongStateCN }}</span>
                <span v-if="scope.row.ConsultingLongStateCN == '转介申请已同意'" style="background-color: rgba(21, 191, 109, 0.1);color: rgba(21, 191, 109, 1);">{{ scope.row.ConsultingLongStateCN }}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('original.languages49')" min-width="15%" align="center">
              <template slot-scope="scope">
                <span @click="
                dialoginfoVisible = true
                  SetAppointmentInfo(scope.row)
                " class="table_btn">
                   {{ $t('original.languages174') }}
                </span>
                <span v-if="scope.row.ConsultingLongStateCN == '申请中'" @click="evocation(scope.row.ConsultingLongID)"
                  class="table_btn">
                   撤回
                </span>
              </template>
            </el-table-column>

          </el-table>

          <div class="block">
            <el-pagination @current-change="handleCurrentC" :current-page.sync="form.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Count"></el-pagination>
          </div>

        </el-row>
      </el-main>
    </el-container>

    <el-dialog :title="$t('original.languages232')" :visible.sync="outerVisible" width="80%">
      <div class="dialog_left" v-if="entity == '管理员'">
        <el-input v-model="taocan" :placeholder="$t('original.languages279')"></el-input>
        <el-button type="primary" @click="xacs()"> {{ $t('original.search') }}</el-button>
        <ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto;">
          <li style="cursor: pointer;" v-for="itme in zxunshidata" :key="itme.ConsultingLongID" class="infinite-list-item"
            @click="studentslist(itme.CounselorID, 1)">
            {{ itme.CounselorName }}
          </li>
        </ul>
      </div>

      <div :class="entity == '管理员' ? 'no-width' : 'all-width'">
        <el-table class="Page" :data="studentslists" style="width: 100%;" v-loading="IsLoading"
          element-loading-background="rgba(255,255,255,1)" :element-loading-text="$t('original.languages22')"
          element-loading-spinner="el-icon-loading">
          <el-table-column :label="$t('original.The_serial_number')" min-width="6%" align="left">
            <template slot-scope="scope" center>
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="VisitorName" :label="$t('original.name')" min-width="10%"></el-table-column>
          <el-table-column prop="ConsultingLongCause" :label="$t('original.languages213')" min-width="10%"></el-table-column>
          <el-table-column prop="ConsultingLongTime" :label="$t('original.languages272')" min-width="10%"></el-table-column>
          <el-table-column prop="ConsultingLongNotes" :label="$t('original.languages280')" min-width="10%"></el-table-column>
          <el-table-column prop="ApproverTime" :label="$t('original.languages193')" min-width="10%"></el-table-column>
          <el-table-column :label="$t('original.languages49')" min-width="10%" align="center">
            <template slot-scope="scope">
              <span @click="ViewDetails(scope.row), (innerVisible = true)" class="table_btn">
               {{ $t('original.languages278') }}
              </span>
              <span @click="introducefun(scope.row)" class="table_btn">申请转介</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="studentslists.length > 0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="10"
            layout="total, prev, pager, next" :total="Counts"></el-pagination>
        </div>
      </div>

      <el-dialog width="30%" :title="$t('original.languages281')" :visible.sync="innerVisible" append-to-body>
        <el-input v-model="liyou"></el-input>
        <el-button type="primary" style="margin-top: 20px; text-align: center; margin-left: 44%;" @click="wppqueding()">
          {{ $t('original.languages59') }}
        </el-button>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="innerVisible = true">打开内层 Dialog</el-button> -->
      </div>
    </el-dialog>

    <el-drawer title="申请转介" :visible.sync="drawer" :with-header="false">
      <div style="width: 100%;height: 20px;"></div>
      <span style="padding: 20px;">咨询师</span>
      <el-select @change="Counselor_change()" style="width: 300px;padding-bottom: 10px;"  v-model="zjls" placeholder="请选择">
        <el-option v-for="(item, i) in Counselor_list" :key="i" :label="item.value" :value="item.key">
          <!-- :disabled="item.Disabled" -->
        </el-option>
      </el-select><br>

      <span style="padding: 20px;">&nbsp;&nbsp;理由</span>
      <el-input style="width: 70%;margin-top:20px;padding-top:20px" type="textarea" :rows="2" placeholder="请输入内容" v-model="zjly">
      </el-input><br>
       <el-button type="primary" @click="zjtifun()" style="margin-top:40px;margin-left:48%"></el-button>
    </el-drawer>

  </div>
</template>
<script>
import add from '../Measurement/add.vue'
export default {
  components: { add },
  mounted() {
    this.RoleID = JSON.parse(sessionStorage.getItem('xinxi')).RoleID;
    this.GetConsultingLong(this.form);
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
      }
    })
    // this.$Http_Post('DepartMent/GetDeparMent', {}).then((res) => {
    //   if (res.Code == 200 || res.Code == 0) {
    //     sessionStorage.setItem('department', JSON.stringify(res.Data))
    //     this.DepartDrop = res.Data;
    //   }
    // })
  },
  data() {
    return {
      iscontinuous:false,
      pasx1:false,
      pasx2:false,
      ConsultType:'',
      zjls:'',
      zjly:'',
      zjConsultingLongID:'',
      drawer: false,
      data:[],
      Counselor: '',
      Counselor_list: [],
      RoleID: '',
      aaa1:'',
      aaa1s: '',
      aaa3: '',
      aaa2: [],
      xsdata:[],
      Counts: 0,
      Count: 0,
      ConsultingLongID: '',
      currentPage1: 1,
      liyou: '',
      outerVisible: false,
      innerVisible: false,
      studentslists: [],
      IsLoading: true,
      entity: sessionStorage.getItem('entity'),
      wppUserID: '',
      taocan: '',
      zxunshidata: [],
      load: false,
      dialogTableVisible: false,// 添加取消预约弹框
      addInformationShow: false,//控制添加申请附加信息显示
      dialoginfoVisible: false,
      loadingstart: false,
      VsitorNameList: [],
      tableData: [], //列表表格数据
      DepartDrop: [],
      form: {
        entity: sessionStorage.getItem('entity'),
        CancelApproval: '',
        UserID: '',
        DepartID: '',
        pageSize: '10',
        pageIndex: '1',
      },
      addInformation: {
        AppointmentID: '',
        RealName: JSON.parse(localStorage.getItem('userInfo')).UserName,
        UserID: '', //来访者姓名
        DeptName: '',
        ConsultTheme: '',
        ConsultCntIntroduce: '',
        ConsultingLongWeek: '',
        ConsultingLongtime: '',
        ConAddressName: '',
        ConsultThConsultTypeeme: '',
        ConsultingLongCause: '',
        Rest: '',
      },
      AppointmentInfo: {
        ConsultingLongID: '',
        RealName: '',
        UserID: '',
        Sex: '',
        DeptName: '',
        CounselorID: '',
        ConsultTheme: '',
        ConAddressName: '',
        ConsultType: '',
        ConsultCntIntroduce: '',
        ConsultingLongNotes: '',
        ConsultingLongState: '',
        ConsultingLongCause: '',
        ApproverID: '',
        ApproverTime: '',
        CreatedTime: '',
        aaa1: '',
        aaa2: '',
        ConsultingLongStateCN: '',
      },
      evocationload:false,
    }
  },
  methods: {
    xztm(val){
      this.ConsultType = ''
      for(var i = 0;i<this.aaa2.length;i++){
        if(val == this.aaa2[i].Time){
          if(this.aaa2[i].ConsultType == '0'){
            this.pasx1 = false;
            this.pasx2 = true;
          }else if(this.aaa2[i].ConsultType == '1'){
            this.pasx2 = false;
            this.pasx1 = true;
          }else if(this.aaa2[i].ConsultType == '1,0'){
            this.pasx1 = false;
            this.pasx2 = false;
          }
        }
      }
    },
    zjtifun(){
      this.$Http_Post('ConsultSubscribe/GetsqUpdateConsultingLong', {
        ConsultingLongID: this.zjConsultingLongID,
        ApplyReason: this.zjly,
        ReferConsultant: this.zjls,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.innerVisible = false;
          this.liyou = '';
          this.GetConsultingLong(this.form);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    introducefun(row){
      this.zjConsultingLongID = row.ConsultingLongID
      this.$Http_Post('ConsultSubscribe/GetCounselor', {}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Counselor_list = res.Data;
            this.drawer = true;
          }
        })
    },
    Selected_to_shut_dow(dt) {
      this.form.DepartID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },
    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },
    bumen(dt) {
      let obj = this.data[0]
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      let _this = this;
      
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      } else {

      }
    },
    aaa1fun() {
      this.form.pageIndex = 1
      this.GetConsultingLong(this.form)
    },
    Counselor_change() {

      this.$Http_Post('ConsultSubscribe/GetLongNameList', {Counselor: this.Counselor}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.VsitorNameList = res.Data
        } else {
          this.Global.request_failure(res.Message);
        }
      })

      this.$Http_Post('ConsultSubscribe/GetNextWeekSchedule', { Counselor: this.Counselor }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.xsdata = res.Data;
          this.aaa1 = res.Data[0].Day;
          this.aaa2 = res.Data[0].TimeList;
          this.aaa1s = res.Data[0].Day;
        }
      })

    },
    zxtime() {
      // this.addInformation.ConsultingLongWeek = this.VsitorNameList[index].ConsultingLongWeek;
      for (let index = 0; index < this.xsdata.length; index++) {
        if (index == this.aaa1) {
          this.aaa2 = this.xsdata[index].TimeList;
          this.aaa1s = this.xsdata[index].Day
        }
      }
      this.addInformation.ConsultingLongtime = ''
    },
    handleCurrentC(val) {
      this.form.pageIndex = val;
      this.GetConsultingLong(this.form)
    },
    handleCurrentChange(val) {
      this.studentslist(this.wppUserID, val);
    },

    wppqueding() {
      this.$Http_Post('ConsultSubscribe/GetsqUpdateConsultingLong', {ConsultingLongID: this.ConsultingLongID,ApplyReason: this.liyou}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.innerVisible = false;
          this.liyou = '';
          this.GetConsultingLong(this.form);
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    ViewDetails(val) {
      this.ConsultingLongID = val.ConsultingLongID;
    },
    xacs() {
      this.$Http_Post('ConsultSubscribe/GetZxConsultingLong', {pageSize: 10,pageIndex: 1,Name: this.taocan}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.zxunshidata = res.Data;
          this.IsLoading = false;
          if (res.Data.length >= 1) {
            this.wppUserID = res.Data[0].CounselorID;
            this.studentslist(this.wppUserID, 1)
          } else {
            this.studentslist(this.wppUserID, 1)
          }
        }
      })
    },
    studentslist(UserID, pageIndex) {
      this.IsLoading = true;
      var sxscd;

      if (UserID.CounselorID) {
        this.wppUserID = UserID.CounselorID;
      } else {
        this.wppUserID = UserID;
      }

      this.$Http_Post('ConsultSubscribe/GetLFZConsultingLong', {UserID: this.wppUserID,pageSize: 10,pageIndex: pageIndex,Name: this.taocan,}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.studentslists = res.Data;
          this.Counts = res.Counts;
          this.IsLoading = false;
        }
      })
    },
    handleClose(done) {
      this.$confirm(this.$t('original.languages60'))
        .then((_) => {
          done()
        })
        .catch((_) => { })
    },
    getVsitorNameList() {
      this.addInformation.UserID = ''
      this.addInformation.ConsultingLongCause = ''
      this.addInformation.ConsultingLongWeek = ''
      this.addInformation.ConsultingLongtime = ''
      this.addInformation.AppointmentID = ''
      this.ConsultType = ''
      if (this.Global.pdroleid(1057)) {
        this.dialogTableVisible = true;
        this.$Http_Post('ConsultSubscribe/GetCounselor', {}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Counselor_list = res.Data
          }
        })
      } else {
        this.loadingstart = true;
        this.$Http_Post('ConsultSubscribe/GetLongNameList', {}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadingstart = false
            this.VsitorNameList = res.Data
            if (res.Data.length == 0) {
              this.$message(this.$t('original.languages282'));
            } else {
              this.dialogTableVisible = true
            }
          }
        })
        this.$Http_Post('ConsultSubscribe/GetNextWeekSchedule', { Counselor: JSON.parse(sessionStorage.getItem("xinxi")).UserID }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.xsdata = res.Data;
            this.aaa1 = res.Data[0].Day;
            this.aaa2 = res.Data[0].TimeList;
            this.aaa1s = res.Data[0].Day;
          }
        })
      }
    },
    selectVsitorName() {
      for (let index = 0; index < this.VsitorNameList.length; index++) {
        if (index == this.addInformation.UserID) {
          this.addInformationShow = true;
          this.addInformation.DeptName = this.VsitorNameList[index].DeptName;
          this.addInformation.ConsultTheme = this.VsitorNameList[index].ConsultTheme;
          this.addInformation.ConsultCntIntroduce = this.VsitorNameList[index].ConsultCntIntroduce;
          this.addInformation.ConsultingLongWeek = this.VsitorNameList[index].ConsultingLongWeek;
          this.addInformation.ConAddressName = this.VsitorNameList[index].ConAddressName;
          this.addInformation.ConsultType = this.VsitorNameList[index].ConsultType;
          this.addInformation.DeptName = this.VsitorNameList[index].DeptName;
          this.addInformation.AppointmentID = this.VsitorNameList[index].AppointmentID;
          this.addInformation.UserID = this.VsitorNameList[index].UserID;
          this.addInformation.Rest = this.VsitorNameList[index].Rest;
        }
      }
    },

    clearAddInformation() {
      this.addInformationShow = false;
      this.addInformation.AppointmentTime = '';
      this.addInformation.ConAddressName = '';
      this.addInformation.ConsultType = '';
      this.addInformation.CancelCause = '';
      this.addInformation.ConsultCntIntroduce = '';
      this.addInformation.ConsultTheme = '';
      this.addInformation.UserID = '';
      this.addInformation.DeptName = '';
    },

    AddConsultingLong() {

      if(this.addInformation.Rest>0){
        this.iscontinuous = true
        //申请解禁
        this.$Http_Post('ConsultSubscribe/AddConsultingLong', {
          UserID: this.addInformation.UserID, //来访者
          ConsultingLongCause: this.addInformation.ConsultingLongCause,
          // ConsultingLongWeek: this.addInformation.ConsultingLongWeek,
          ConsultingLongWeek: this.aaa1s.slice(10, 14),
          ConsultingLongtime: this.addInformation.ConsultingLongtime,
          AppointmentID: this.addInformation.AppointmentID,
          ConsultingLongDate: this.aaa1s.slice(0, 10),
          Counselor: this.Counselor,
          ConsultType: this.ConsultType,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.iscontinuous = false
            this.Global.request_successful(res.Message);
            this.addInformation.UserID = '';
            this.GetConsultingLong(this.form);
            this.dialogTableVisible = false;
          } else {
            this.iscontinuous = false
            this.Global.request_failure(res.Message);
          }
        })
      }else{
        this.Global.request_failure('该学员剩余咨询次数已耗尽，请先解禁次数!');
      }

      
    },

    GetConsultingLong(form) {
      this.load = true;
      this.$Http_Post('ConsultSubscribe/GetConsultingLong', { form }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.tableData = res.Data.Lists;
            this.Count = res.Counts;
            this.load = false;
          }
        },
      )
    },

    clearFrom() {
      this.form.CancelApproval = '';
      this.form.UserID = '';
      this.form.DepartID = '';
      this.form.pageIndex = 1;
      this.GetConsultingLong(this.form);
    },

    SetAppointmentInfo(row) {
      console.log(row)
      this.AppointmentInfo.ApproverID = row.ApproverID;
      this.AppointmentInfo.ApproverTime = row.ApproverTime;
      this.AppointmentInfo.ConAddressName = row.ConAddressName;
      this.AppointmentInfo.ConsultCntIntroduce = row.ConsultCntIntroduce;
      this.AppointmentInfo.ConsultTheme = row.ConsultTheme;
      this.AppointmentInfo.ConsultType = row.ConsultType;
      this.AppointmentInfo.ConsultingLongCause = row.ConsultingLongCause;
      this.AppointmentInfo.ConsultingLongID = row.ConsultingLongID;
      this.AppointmentInfo.ConsultingLongNotes = row.ConsultingLongNotes;
      this.AppointmentInfo.ConsultingLongState = row.ConsultingLongState;
      this.AppointmentInfo.ConsultingLongStateCN = row.ConsultingLongStateCN;
      this.AppointmentInfo.CounselorID = row.CounselorID;
      this.AppointmentInfo.CreatedTime = row.CreatedTime;
      this.AppointmentInfo.DeptName = row.DeptName;
      this.AppointmentInfo.RealName = row.RealName;
      this.AppointmentInfo.UserID = row.UserID;
      this.AppointmentInfo.aaa1 = row.ConsultingLongWeek;
      this.AppointmentInfo.aaa2 = row.ConsultingLongTime;
    },

    evocation(ConsultingLongID) {
      this.evocationload=true;
      this.$Http_Post('ConsultSubscribe/UpdateConsultingLong', {
        ConsultingLongID: ConsultingLongID,
        ConsultingLongState: 4,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.GetConsultingLong(this.form);
          this.$message({ message: this.$t('original.languages259'), type: 'success' })
          this.dialogTableVisible = false
          this.dialoginfoVisible = false
          for (let index = 0; index < this.tableData.length; index++) {
            if (ConsultingLongID == this.tableData[index].ConsultingLongID) {
              this.tableData[index].ConsultingLongState = 4
            }
          }
        }
        this.evocationload=true;
      })
    },
  },
}
</script>
<style>
.ConsultingLong .dialog_left {
  float: left;
  width: 260px;
  height: 660px;
}

.ConsultingLong .dialog_right {
  height: 660px;
  float: right;
}

.all_width {
  width: 100%;
}

.no-width {
  width: calc(100% - 260px);
  float: right;
  height: 650px;
  overflow: auto;
}

.ConsultingLong .infinite-list li {
  height: 40px;
  margin-top: 10px;
  line-height: 40px;
  text-align: center;
}

.ConsultingLong .dialog_left .el-input__inner {
  width: 60%;
  float: left;
}

.ConsultingLong .dialog_left {
  position: relative;
}

.ConsultingLong .dialog_left .el-button {
  position: absolute;
  right: 5px;
  top: 4px;
}

.ConsultingLong .el-dialog {
  height: 770px !important;
}

.ConsultingLong .td_left {
  color: rgba(141, 141, 141, 1);
  font-size: 14px;
  padding: 5px 15px;
}

.ConsultingLong .td_right {
  text-align: left;
  font-size: 14px;
  color: rgba(40, 40, 40, 1);
}

.el-dialog {
  height: auto !important;
}

.ConsultingLong .buttons {
  width: 100%;
  text-align: center;
  margin: 20px;
}

.ConsultingLong .Statusblue {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(29, 154, 255, 0.1);
  color: rgba(29, 154, 255, 1);
}

.ConsultingLong .Statusgreen {
  border-radius: 4px;
  background-color: rgba(21, 191, 109, 0.1);
  color: rgba(21, 191, 109, 1);
  padding: 5px 10px;
}

.ConsultingLong .Statusred {
  border-radius: 4px;
  background-color: rgba(242, 75, 78, 0.1);
  color: rgba(242, 75, 78, 1);
  padding: 5px 10px;
}

.ConsultingLong .Statusgray {
  border-radius: 4px;
  padding: 5px 10px;
  background: rgba(141, 141, 141, 0.1);
  color: rgba(141, 141, 141, 1);
}

.ConsultingLong .block {
  float: right;
}
.el-table--enable-row-transition .el-table__body td{text-align: center;}
</style>
